import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AddIcon from '@mui/icons-material/Add';

const WhatIsSection = () => {
  const FeatureBox = ({ icon: Icon, title, description }) => (
    <Paper
      elevation={2}
      sx={{
        p: 4,
        height: '100%',
        width: '100%',
        maxWidth: 400,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        borderRadius: 4,
        backgroundColor: 'white',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-8px)',
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: 'primary.main',
          borderRadius: '50%',
          p: 2,
          mb: 2,
        }}
      >
        <Icon sx={{ fontSize: 40, color: 'white' }} />
      </Box>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: 600,
          mb: 2,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          lineHeight: 1.6,
          maxWidth: '32ch',
          mx: 'auto',
        }}
      >
        {description}
      </Typography>
    </Paper>
  );

  return (
    <Box
      id="whatIsDivscore"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: 'background.paper',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          align="center"
          gutterBottom
          sx={{
            mb: { xs: 4, md: 6 },
          }}
        >
          What is DivScore?
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'center',
            gap: { xs: 4, md: 2 },
          }}
        >
          <FeatureBox
            icon={AssessmentIcon}
            title="Scientific Analysis"
            description="Advanced portfolio analysis using proven financial metrics and sophisticated algorithms to evaluate your dividend portfolio"
          />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 2,
            }}
          >
            <Paper
              elevation={0}
              sx={{
                backgroundColor: 'primary.main',
                borderRadius: '50%',
                width: 60,
                height: 60,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transform: { xs: 'rotate(90deg)', md: 'rotate(0deg)' },
              }}
            >
              <AddIcon sx={{ fontSize: 40, color: 'white' }} />
            </Paper>
          </Box>

          <FeatureBox
            icon={TrendingUpIcon}
            title="Actionable Guidance"
            description="Clear, specific recommendations to optimize your portfolio's performance and reduce risk while maximizing dividend growth"
          />
        </Box>

        <Typography
          variant="body1"
          align="center"
          sx={{
            mt: 6,
            maxWidth: 800,
            mx: 'auto',
            color: 'text.secondary',
          }}
        >
          DivScore combines quantitative analysis with practical recommendations,
          helping you build a stronger dividend portfolio based on proven strategies.
        </Typography>
      </Container>
    </Box>
  );
};

export default WhatIsSection;